var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{class:{ 'is-error': _vm.showError },style:('width:100%'),attrs:{"value":_vm.value,"type":_vm.type,"placeholder":_vm.placeholder,"size":_vm.size,"format":"dd/MM/yyyy","value-format":"yyyy-MM-dd","disabled":_vm.disabled},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }